import { NgModule, LOCALE_ID } from '@angular/core';
import * as ngCommon from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { ModalModule, TooltipModule, TabsModule } from 'ngx-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/layout/header.component';
import { HeaderNotificationsComponent } from './shared/layout/notifications/header-notifications.component';
import { SideBarMenuComponent } from './shared/layout/nav/side-bar-menu.component';
import { TopBarMenuComponent } from './shared/layout/nav/top-bar-menu.component';
import { FooterComponent } from './shared/layout/footer.component';
import { LoginAttemptsModalComponent } from '@app/shared/layout/login-attempts-modal.component';
import { ChangeProfilePictureModalComponent } from '@app/shared/layout/profile/change-profile-picture-modal.component';
import { MySettingsModalComponent } from '@app/shared/layout/profile/my-settings-modal.component';
import { SmsVerificationModalComponent } from '@app/shared/layout/profile/sms-verification-modal.component';
import { AbpModule } from '@abp/abp.module';
import { UtilsModule } from '@shared/utils/utils.module';
import { AppCommonModule } from './shared/common/app-common.module';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { ImpersonationService } from './admin/users/impersonation.service';
import { LinkedAccountService } from './shared/layout/linked-account.service';
import { LinkedAccountsModalComponent } from '@app/shared/layout/linked-accounts-modal.component';
import { CookieService } from 'shared/utils/cookie.service';
import { ApptokenService } from 'shared/utils/apptoken.service';
import { CorreiosService } from 'app/shared/common/correios/correios.service';
import { LinkAccountModalComponent } from '@app/shared/layout/link-account-modal.component';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { NotificationSettingsModalComponent } from './shared/layout/notifications/notification-settings-modal.component';
import { UserNotificationHelper } from './shared/layout/notifications/UserNotificationHelper';
import { ChatBarComponent } from './shared/layout/chat/chat-bar.component';
import { ChatFriendListItemComponent } from './shared/layout/chat/chat-friend-list-item.component';
import { ChatSignalrService } from '@app/shared/layout/chat/chat-signalr.service';
import { QuickSideBarChat } from '@app/shared/layout/chat/QuickSideBarChat';
import { DataTableModule, AutoCompleteModule, InputMaskModule } from 'primeng/primeng';
import { PaginatorModule } from 'primeng/primeng';
import { FileUploadModule as PrimeNgFileUploadModule, ProgressBarModule } from 'primeng/primeng';
import { ChatMessageComponent } from './shared/layout/chat/chat-message.component';
import { CurrencyPipe } from '@angular/common';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { CustomCurrencyMaskConfig } from '@shared/UtilsConsts';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ng2-currency-mask/src/currency-mask.config";
import { ToggleButtonModule } from 'primeng/primeng';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { CreateOrEditUserModalComponent } from '@app/admin/users/create-or-edit-user-modal.component';
import { OrganizationUnitsTreeComponent } from '@app/admin/shared/organization-unit-tree.component';
import { CertificateModalComponent } from '@app/event/my-registrations/modal/certificate-modal.component';
import { VisualizeUserModalComponent } from '@app/admin/users/visualize-user-modal.component';
import { ReceiptModalComponent } from '@app/financial/receivables/modals/receipt/receipt-modal.component';
import { TicketInfoModalComponent } from '@app/financial/payment/modals/ticket-info-modal.component';
import { CartHelperService } from './store/cart/cart-helper-service';
import { CartHeaderComponent } from './store/cart-header/cart-header.component';
import { ProgrammingHeaderComponent } from './scientific/programming-header/programming-header.component';
import { ProgrammingHelperService } from './scientific/programming-header/programming-helper-service';
import { HeaderActivitiesComponent } from './admin/adminActivities/header-activities.component'
import { EventWorkHeaderComponent } from './scientific-work/event-work-header/event-work-header.component';
import { EventWorkHelperService } from './scientific-work/event-work-header/event-work-helper-service';


@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        HeaderNotificationsComponent,
        SideBarMenuComponent,
        TopBarMenuComponent,
        FooterComponent,
        LoginAttemptsModalComponent,
        LinkedAccountsModalComponent,
        LinkAccountModalComponent,
        ChangeProfilePictureModalComponent,
        MySettingsModalComponent,
        SmsVerificationModalComponent,
        NotificationsComponent,
        ChatBarComponent,
        ChatFriendListItemComponent,
        NotificationSettingsModalComponent,
        ChatMessageComponent,
        CreateOrEditUserModalComponent,
        OrganizationUnitsTreeComponent,
        CertificateModalComponent,
        VisualizeUserModalComponent,
        ReceiptModalComponent,
        TicketInfoModalComponent,
        CartHeaderComponent,
        ProgrammingHeaderComponent,
        HeaderActivitiesComponent,
        EventWorkHeaderComponent,
    ],
    imports: [
        ngCommon.CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        JsonpModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        TabsModule.forRoot(),
        FileUploadModule,
        AbpModule,
        AppRoutingModule,
        UtilsModule,
        AppCommonModule.forRoot(),
        ServiceProxyModule,
        DataTableModule,
        PaginatorModule,
        PrimeNgFileUploadModule,
        ProgressBarModule,
        CurrencyMaskModule,
        ToggleButtonModule,
        AutoCompleteModule,
        InputMaskModule,
    ],
    exports: [
        CreateOrEditUserModalComponent,
        OrganizationUnitsTreeComponent,
        CertificateModalComponent,
        VisualizeUserModalComponent,
        ReceiptModalComponent,
        TicketInfoModalComponent,
        CartHeaderComponent,
        HeaderActivitiesComponent,
        ProgrammingHeaderComponent,
        EventWorkHeaderComponent,
        HeaderComponent,
        FooterComponent
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        ImpersonationService,
        LinkedAccountService,
        UserNotificationHelper,
        CartHelperService,
        ProgrammingHelperService,
        EventWorkHelperService,
        ChatSignalrService,
        QuickSideBarChat,
        ApptokenService,
        CookieService,
        CorreiosService,
        CurrencyPipe,
        CartHeaderComponent,
        HeaderActivitiesComponent,
        ProgrammingHeaderComponent,
        EventWorkHeaderComponent,
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts